// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  CreatePartnerSubscriptionRequest as ICreatePartnerSubscriptionRequest,
  DefaultApi as PartnerDataApi,
  ConfirmTwoFactorSettingsRequest as PartnerDataApiConfirmTwoFactorSettingsParams,
  DefaultApiConfirmTwoFactorSettingsRequest as PartnerDataApiConfirmTwoFactorSettingsRequest,
  DefaultApiCreatePartnerSubscriptionRequest as PartnerDataApiCreatePartnerSubscriptionRequest,
  DefaultApiGetPartnerAvailableSubscriptionsRequest as PartnerDataApiGetPartnerAvailableSubscriptionsRequest,
  DefaultApiGetTwoFactorSettingsRequest as PartnerDataApiGetTwoFactorSettingsRequest,
  DefaultApiModifyTwoFactorSettingsRequest as PartnerDataApiModifyTwoFactorSettingsRequest,
} from '@eih-netbroker/api-partner-data';
import { AxiosInstance, AxiosResponse } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { Subscription } from '../types';
import { BaseResource } from './base.resource';
export { GetTwoFactorSettingsResponse } from '@eih-netbroker/api-partner-data';

export type GetPartnerAvaiableSubscriptionsParams = Omit<
  PartnerDataApiGetPartnerAvailableSubscriptionsRequest,
  keyof ResourceHeadersWithToken
>;

export type CreatePartnerSubscriptionParams = Omit<
  PartnerDataApiCreatePartnerSubscriptionRequest,
  keyof ResourceHeadersWithToken
>;

export type CreatePartnerSubscriptionRequest = ICreatePartnerSubscriptionRequest;

export type GetTwoFactorSettingsRequest = Omit<
  PartnerDataApiGetTwoFactorSettingsRequest,
  keyof ResourceHeadersWithToken
>;

export type ModifyTwoFactorSettingsRequest = Omit<
  PartnerDataApiModifyTwoFactorSettingsRequest,
  keyof ResourceHeadersWithToken
>;

export type ConfirmTwoFactorSettingsRequest = Omit<
  PartnerDataApiConfirmTwoFactorSettingsRequest,
  keyof ResourceHeadersWithToken
>;

export type ConfirmTwoFactorSettingsParams = PartnerDataApiConfirmTwoFactorSettingsParams;

export class PartnerDataResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'PartnerDataResource';

  private partnerDataApi: PartnerDataApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, `${basePath}${configApi.usUrl.partnerData}`, configApi);
    this.partnerDataApi = new PartnerDataApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.partnerData}`,
      }),
      `${basePath}${configApi.usUrl.partnerData}`,
      axiosInstance,
    );
  }

  getPartnerAvailableSubscriptions(
    request: GetPartnerAvaiableSubscriptionsParams,
    headers: ResourceHeadersWithToken,
  ): Promise<AxiosResponse<Array<Subscription>>> {
    return this.partnerDataApi.getPartnerAvailableSubscriptions({ ...request, ...headers });
  }

  getParnetSubscriptions(request: GetPartnerAvaiableSubscriptionsParams, headers: ResourceHeadersWithToken) {
    return this.partnerDataApi.getPartnerSubscriptions({ ...request, ...headers });
  }

  createSubscriptions = (request: CreatePartnerSubscriptionParams, headers: ResourceHeadersWithToken) => {
    return this.partnerDataApi.createPartnerSubscription({ ...request, ...headers });
  };

  getTwoFactorSettings(request: GetTwoFactorSettingsRequest, headers: ResourceHeadersWithToken) {
    return this.partnerDataApi.getTwoFactorSettings({ ...request, ...headers });
  }

  modifyTwoFactorSettings(request: ModifyTwoFactorSettingsRequest, headers: ResourceHeadersWithToken) {
    return this.partnerDataApi.modifyTwoFactorSettings({ ...request, ...headers });
  }

  confirmTwoFactorSettings(request: ConfirmTwoFactorSettingsRequest, headers: ResourceHeadersWithToken) {
    return this.partnerDataApi.confirmTwoFactorSettings({ ...request, ...headers });
  }

  getVersion() {
    return this.partnerDataApi.getVersion();
  }
}
